/**
 * Calculates review percentage for Bildungsbericht/Kompetenzen
 * - Maps text scale values to numeric points
 * - Deducts 8 points for each "Keine Bewertung" (no rating)
 */

// Mapping of scale options to points
const SCALE_VALUE_MAPPING = {
  "Übertroffen": 8,
  "erfüllt": 6,
  "Knapp erfüllt": 4,
  "Nicht erfüllt": 2,
  "Keine Bewertung": 0,
};

export const calculateReviewPercentage = (answers, template) => {
  if (!template || !answers) {
    return { totalPoints: 0, maxPoints: 0, percentage: 0 };
  }

  // Only calculate for KOMPETENZEN template (check both code and templateCode for compatibility)
  const templateCode = template.templateCode || template.code;
  if (templateCode !== "KOMPETENZEN") {
    return { totalPoints: 0, maxPoints: 0, percentage: 0 };
  }

  let totalPoints = 0;
  let keineBewerungCount = 0;
  let itemCount = 0;

  // Iterate through answers
  Object.entries(answers).forEach(([itemId, answer]) => {
    if (!answer) return;
    
    const scaleValue = answer.scaleValue;
    itemCount++;
    
    // Check for "Keine Bewertung" (no rating)
    if (scaleValue === "Keine Bewertung" || scaleValue === null || scaleValue === undefined || scaleValue === "" || scaleValue === "0") {
      keineBewerungCount++;
    } else if (SCALE_VALUE_MAPPING.hasOwnProperty(scaleValue)) {
      // Add mapped scale value as points
      totalPoints += SCALE_VALUE_MAPPING[scaleValue];
    } else if (!isNaN(scaleValue)) {
      // Fallback for numeric values
      totalPoints += parseInt(scaleValue, 10);
    }
  });

  // Calculate max points
  // Baseline: 8 points per scorable item (excluding "Keine Bewertung")
  // This allows percentages up to 150% when all scorable items are "Übertroffen"
  const scoreableItems = itemCount - keineBewerungCount;
  let maxPoints = scoreableItems * 8;
  
  if (maxPoints < 0) maxPoints = 0;

  // Calculate percentage (scales to 150% max: 128 full points = 150%)
  const percentage = maxPoints > 0 ? Math.round((totalPoints / maxPoints) * 150) : 0;

  return {
    totalPoints,
    maxPoints,
    percentage,
    keineBewerungCount,
    itemCount
  };
};
